import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Sidebar } from '../../shared/sidebar/sidebar';
import { BranchService } from '../../core/services/branch.service';
import { Branch } from '../../core/models/branch.model';

@Component({
  selector: 'app-branches',
  imports: [CommonModule, FormsModule, Sidebar],
  templateUrl: './branches.html',
  styleUrl: './branches.scss',
})
export class Branches implements OnInit {
  searchQuery: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 7;
  totalPages: number = 1;
  visiblePages: number[] = [];
  isLoading: boolean = false;

  branches: Branch[] = [];
  filteredBranches: Branch[] = [];

  constructor(private branchService: BranchService) {}

  ngOnInit() {
    this.loadBranches();
  }

  loadBranches() {
    this.isLoading = true;
    this.branchService.getBranches().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          this.branches = response.data;
          this.filteredBranches = this.branches;
          this.calculatePagination();
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error loading branches:', error);
      }
    });
  }

  calculatePagination() {
    this.totalPages = Math.ceil(this.filteredBranches.length / this.itemsPerPage);
    this.visiblePages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  get paginatedBranches() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.filteredBranches.slice(start, end);
  }

  onSearch() {
    if (!this.searchQuery.trim()) {
      this.filteredBranches = this.branches;
    } else {
      this.filteredBranches = this.branches.filter(branch =>
        branch.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (branch.city && branch.city.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        (branch.address && branch.address.toLowerCase().includes(this.searchQuery.toLowerCase()))
      );
    }
    this.currentPage = 1;
    this.calculatePagination();
  }

  goToPage(page: number) {
    this.currentPage = page;
  }
}
